import { render, staticRenderFns } from "./SearchAnotacoes.vue?vue&type=template&id=5dd26c59&"
import script from "./SearchAnotacoes.vue?vue&type=script&lang=js&"
export * from "./SearchAnotacoes.vue?vue&type=script&lang=js&"
import style0 from "./SearchAnotacoes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports